var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21L19 25L28 16M11.6675 4.63739C13.2752 4.5091 14.8014 3.87691 16.0289 2.83084C18.8934 0.38972 23.1066 0.38972 25.9711 2.83084C27.1986 3.87691 28.7248 4.5091 30.3325 4.63739C34.0841 4.93677 37.0632 7.91589 37.3626 11.6675C37.4909 13.2752 38.1231 14.8014 39.1692 16.0289C41.6103 18.8934 41.6103 23.1066 39.1692 25.9711C38.1231 27.1986 37.4909 28.7248 37.3626 30.3325C37.0632 34.0841 34.0841 37.0632 30.3325 37.3626C28.7248 37.4909 27.1986 38.1231 25.9711 39.1692C23.1066 41.6103 18.8934 41.6103 16.0289 39.1692C14.8014 38.1231 13.2752 37.4909 11.6675 37.3626C7.91589 37.0632 4.93677 34.0841 4.63739 30.3325C4.5091 28.7248 3.87691 27.1986 2.83084 25.9711C0.38972 23.1066 0.38972 18.8934 2.83084 16.0289C3.87691 14.8014 4.5091 13.2752 4.63739 11.6675C4.93677 7.91589 7.91589 4.93677 11.6675 4.63739Z",
    stroke: "#609F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.bd80c161805782f346284b4eedfd29b3.svg";
export { ForwardRef as ReactComponent };